// a react-three-fiber scene
import React, { useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { Html, MapControls } from "@react-three/drei";
import { softShadows } from "@react-three/drei";

import create from "zustand";
import { Hall } from "./Scene2";
import { configurePersist } from "zustand-persist";
import Login from "./Login";

const { persist } = configurePersist({
  storage: localStorage, // use `AsyncStorage` in react native
  rootKey: "root212", // optional, default value is `root`
});

const useDND = create(
  persist(
    {
      key: "auth", // required, child key of storage
    },
    (set, get) => ({
      mouseDown: false,
      targetTile: [0, 0],
      set: (d) => set(d),
      setMouseDown: (b = true) => set({ mouseDown: b }),
      setTargetTile: (d) => set({ targetTile: d }),
      currentLayout: "Default",
      layouts: ["Default", "Neu 1"],
      cubes: {},
      setCubeByKey: (k, v) =>
        set({
          cubes: { ...get().cubes, [k]: { ...(get().cubes[k] || {}), ...v } },
        }),
    })
  )
);

softShadows();
export default function Scene() {
  /*
          <Cube position={[-2, 2]}></Cube>
        <Cube position={[-2, 1]}></Cube>
        <Cube position={[-2, 0]}></Cube>
        <Cube small color="#aaa" position={[-1, 0]}></Cube>
        <Cube position={[-4, 2]}></Cube>
        <Cube></Cube>
        <Cube color="red" position={[1, 0]}></Cube>
        <Cube small color="#aaa" position={[4, 2]}></Cube>
        <Cube small color="#aaa" position={[3, 0]}></Cube>
        <Cube small color="#aaa" position={[2, 0]}></Cube>
        <Cube small color="#aaa" position={[-3, 2]}></Cube>
        <Cube color="teal" small position={[-2, 3]}></Cube>
        <Cube color="teal" small position={[-2, 4]}></Cube>
        <Cube color="teal" small position={[-2, 5]}></Cube>
        <Cube color="teal" small position={[-2, 6]}></Cube>
        <Cube position={[3, 1]}></Cube>
        <Cube position={[3, 2]}></Cube>
        <Cube position={[5, 2]}></Cube>
        <Cube position={[6, 2]}></Cube>
  */
  let { mouseDown, cubes, currentLayout } = useDND();
  return (
    <div style={{ height: "100%" }}>
      <Login startOpen></Login>
      <Canvas
        draggable
        orthographic
        shadows
        camera={{ position: [5, 5, 5], zoom: 90, near: -20 }}
      >
        <Floor></Floor>
        <Hall name="" w={7} h={2} position={[-1.5, -3]}></Hall>
        <DNDLayer></DNDLayer>
        <CubeSource position={[-1 + 1, -3]} color={"green"}></CubeSource>
        <CubeSource position={[-2 + 1, -3]} color={"yellow"}></CubeSource>
        <CubeSource position={[-3 + 1, -3]} color={"red"}></CubeSource>
        <CubeSource position={[-4 + 1, -3]} color={"blue"}></CubeSource>
        <CubeSource
          position={[-5 + 1, -3]}
          color={"#444"}
          small={true}
        ></CubeSource>
        <CubeSource position={[1, -3]} color={"#fff"} type="hall"></CubeSource>
        {Object.values(cubes)
          .filter((c) => c.layout === currentLayout)
          .map((v) => {
            if (v.type === "cube") {
              return (
                <Cube
                  key={v.id}
                  id={v.id}
                  position={v.position}
                  color={v.color}
                  small={v.small}
                />
              );
            }
            if (v.type === "hall") {
              return (
                <DraggableHall
                  key={v.id}
                  id={v.id}
                  position={v.position}
                  w={v.w}
                  h={v.h}
                  name={v.name}
                />
              );
            }
            return null;
          })}
        <MapControls enabled={!mouseDown}></MapControls>
        <directionalLight
          castShadow
          position={[2.5, 8, 5]}
          intensity={1.5}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-far={50}
          shadow-camera-left={-10}
          shadow-camera-right={10}
          shadow-camera-top={10}
          shadow-camera-bottom={-10}
        />
        <ambientLight intensity={1}></ambientLight>
      </Canvas>
      <Sidebar></Sidebar>
    </div>
  );
}
function DNDLayer() {
  let ref = useRef();
  let { mouseDown, setMouseDown, setCubeByKey, currentLayout } = useDND();

  return (
    <mesh
      onPointerMove={(e) => {
        //console.log(e);
        if (mouseDown) {
          let targetTile = [
            Math.floor(e.point.x + 0.5),
            Math.floor(e.point.z + 0.5),
          ];
          if (
            true ||
            (targetTile[0] > -6 &&
              targetTile[0] < 4 &&
              targetTile[1] > -5 &&
              targetTile[1] < 3)
          ) {
            setCubeByKey(mouseDown, {
              id: mouseDown,
              position: targetTile,
              layout: currentLayout,
            });
          } else {
            setCubeByKey(mouseDown, undefined);
          }
        }
      }}
      onPointerUp={(e) => {
        setMouseDown(false);
      }}
      position={[0, 0, 0]}
      ref={ref}
    >
      <boxBufferGeometry args={[2000, 1, 2000]} />
      <meshStandardMaterial
        transparent
        color={"#000"}
        opacity={0}
      ></meshStandardMaterial>
    </mesh>
  );
}

export function Floor({ color = "#bbb" }) {
  return (
    <mesh position={[0, -1, 0]} castShadow receiveShadow>
      <boxBufferGeometry args={[2000, 1, 2000]} />
      <meshStandardMaterial color={color}></meshStandardMaterial>
    </mesh>
  );
}
function DraggableHall({
  w = 10,
  h = 5,
  name = "HALLE 1",
  position = [0, 0],
  id,
}) {
  let { setMouseDown } = useDND();
  return (
    <group
      onPointerDown={(e) => {
        e.stopPropagation();
        setMouseDown(id);
      }}
      onPointerUp={(e) => {
        setMouseDown(null);
      }}
      position={[position[0], 0, position[1]]}
    >
      <Hall w={w} h={h} name={name}></Hall>
    </group>
  );
}
function Cube({ position = [0, 0], color = "green", small = false, id }) {
  const [popup] = React.useState(false);
  let { setMouseDown } = useDND();
  let size = small ? 0.3 : 0.9;
  return (
    <mesh
      castShadow
      position={[position[0], 1, position[1]]}
      onPointerDown={(e) => {
        e.stopPropagation();
        setMouseDown(id);
      }}
      onPointerUp={(e) => {
        setMouseDown(null);
      }}
    >
      <boxBufferGeometry args={[size, size, size]} />
      <meshStandardMaterial color={color}></meshStandardMaterial>
      {popup && (
        <Html>
          <div className="popup">
            <div className="head">DLP Press #1</div>
            {color === "green" ? (
              <div className="statusWrapper">
                <div className="status">
                  <div className="dot"></div>
                  Läuft
                </div>
              </div>
            ) : (
              <div className="statusWrapper error">
                <div className="status">
                  <div className="dot"></div>
                  Fehler #339
                </div>
                <div className="text">Druckgruppe 2 Temperatur überprüfen</div>
                <div className="status">
                  <div className="dot"></div>
                  Fehler #3349
                </div>
                <div className="text">Druckgruppe 1 Temperatur überprüfen</div>
              </div>
            )}
          </div>
        </Html>
      )}
    </mesh>
  );
}

function CubeSource({
  position = [0, 0],
  color = "green",
  small = false,
  type = "cube",
}) {
  let { mouseDown, setMouseDown, setCubeByKey, cubes, set } = useDND();
  let size = small ? 0.3 : 0.9;

  return (
    <mesh
      castShadow
      position={[position[0], 1, position[1]]}
      onPointerDown={(e) => {
        //create new cube
        let newId = Math.floor(Math.random() * 10000);
        setCubeByKey(newId, {
          id: newId,
          position,
          color,
          small,
          type,
          w: Math.floor(Math.random() * 8) * 2 + 3,
          h: Math.floor(Math.random() * 8) * 2 + 3,
          name: "Halle " + Math.floor(Math.random() * 50),
        });
        setMouseDown(newId);
        e.stopPropagation();
      }}
      onPointerUp={(e) => {
        //if dragging, remove
        if (mouseDown) {
          let newCubes = { ...cubes };
          delete newCubes[mouseDown];
          set({ cubes: newCubes });
        }
        setMouseDown(null);
      }}
    >
      <boxBufferGeometry args={[size, size, size]} />
      <meshStandardMaterial color={color}></meshStandardMaterial>
    </mesh>
  );
}

function Sidebar() {
  let { set, currentLayout, layouts } = useDND();
  return (
    <div className="sidebar">
      <select
        value={currentLayout}
        onChange={(e) => set({ currentLayout: e.target.value })}
      >
        {layouts.map((l) => {
          return <option value={l}>{l}</option>;
        })}
      </select>
      <button
        onClick={() => {
          let newLay = "Layout " + Math.floor(Math.random() * 1000);
          set({
            layouts: [...layouts, newLay],
            currentLayout: newLay,
          });
        }}
      >
        Neues Layout
      </button>
    </div>
  );
}
